import { HOST_URL, URL_VERSION } from '../constants';

import get_header from "./api_header";

export function podcastsSuccess(payload) {
  
  return {
      type: 'PODCASTS_SUCCESS',
      payload
  }
}

export function allPodcasts(authentication_token, success,error) {
  return (dispatch) => {
    return fetch(HOST_URL+'api/v1/episodes', {
      method: 'GET',
      headers: get_header(authentication_token),
    })
    .then((response) => {
      if (response.ok) {
        response.json().then((responseJson) => {
          
          dispatch(podcastsSuccess(responseJson));
          success(responseJson)
        })
      }
      else if(response.status !== 401){
        error()
      }
    })
    .catch((error) => {
      console.error(error);
    });
  }
}


